import { Component, Input, Output, EventEmitter, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-timer',
  templateUrl: 'rmt-timer.html'
})
export class RmtTimerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() seconds: number;
  // When hideLabel true, renders only MM:SS without the translated prefix/suffix text
  @Input() hideLabel = false;
  @Output() finished = new EventEmitter<void>();
  @Output() tick = new EventEmitter<number>();

  displayTime: string = '';
  translatedPrefix: string = '';
  translatedSuffix: string = '';

  private intervalId: any;
  private startTimestamp: number;
  private totalSeconds: number;
  private remainingSeconds: number;

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.loadTranslation();

    this.totalSeconds = this.seconds;
    this.startTimestamp = Date.now();

    this.updateDisplayTime(this.seconds);
    this.tick.emit(this.seconds);

    this.intervalId = setInterval(() => {
      const elapsed = Math.floor((Date.now() - this.startTimestamp) / 1000);
      const remaining = this.totalSeconds - elapsed;

      if (remaining <= 0) {
        this.displayTime = '00:00';
        this.tick.emit(0);
        clearInterval(this.intervalId);
        this.finished.emit();
      } else {
        this.updateDisplayTime(remaining);
        this.tick.emit(remaining);
      }
    }, 1000);
  }

  private loadTranslation() {
    if (this.hideLabel)
      return;
    const key = 'Page.editRecipientDetails.editDetailsTimer';
    this.translate.get(key).subscribe((res: string) => {
      const parts = res.split('{{time}}');
      //safety check in case of missing translations
      this.translatedPrefix = parts[0] || '';
      this.translatedSuffix = parts[1] || '';
    });
  }

  private updateDisplayTime(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    this.displayTime = `${this.pad(minutes)}:${this.pad(secs)}`;
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private restartTimer(newSeconds: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.totalSeconds = newSeconds;
    this.startTimestamp = Date.now();
    this.remainingSeconds = newSeconds;

    this.updateDisplayTime(newSeconds);
    this.tick.emit(newSeconds);

    this.intervalId = setInterval(() => {
      const elapsed = Math.floor((Date.now() - this.startTimestamp) / 1000);
      const remaining = Math.max(this.totalSeconds - elapsed, 0);
      this.remainingSeconds = remaining;

      if (remaining <= 0) {
        this.displayTime = '00:00';
        this.tick.emit(0);
        clearInterval(this.intervalId);
        this.finished.emit();
      } else {
        this.updateDisplayTime(remaining);
        this.tick.emit(remaining);
      }
    }, 1000);
  }

  ngOnChanges(changes: any) {
    if (changes.seconds && !changes.seconds.firstChange) {
      const newSeconds = changes.seconds.currentValue;
      const now = Date.now();
      const elapsed = Math.floor((now - this.startTimestamp) / 1000);
      const currentRemaining = Math.max(this.totalSeconds - elapsed, 0);

      if (newSeconds > currentRemaining) {
        this.restartTimer(newSeconds);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-timer/rmt-timer.ts